import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdeal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=IDEAL",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle-31",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M25.4545 19.7263L15 19.7273V4H25.4545C29.7346 4.06002 33.1818 6.94823 33.1818 11.8636C33.1818 16.779 29.7346 19.6663 25.4545 19.7263ZM25.3636 18.9091H15.8182V4.81818H25.3636C29.4689 4.83834 32.3636 7.5901 32.3636 11.8636C32.3636 16.1372 29.4689 18.8889 25.3636 18.9091Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle-31_2",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.909 12.9091H19.6363V17.8182H16.909V12.9091ZM18.2727 12.1818C19.2266 12.1818 20 11.4085 20 10.4546C20 9.50062 19.2266 8.72729 18.2727 8.72729C17.3187 8.72729 16.5454 9.50062 16.5454 10.4546C16.5454 11.4085 17.3187 12.1818 18.2727 12.1818Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle-32",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M31.2454 11.1819C30.8125 5.90918 25.3635 5.90918 25.3635 5.90918H21.0908V17.8183H25.3635C25.3635 17.8183 31.1821 17.8183 31.2716 12.0001H29.2726V8.81827H30.0908V11.1819H31.2454ZM23.4545 8.81827H25.3635V9.63645H24.2726V10.0001H25.2726V10.7274H24.2726V11.1819H25.4545V12.0001H23.4545V8.81827ZM22.2393 10.4092C22.2393 9.63645 21.7272 9.63645 21.7272 9.63645H21.0908V8.81827H21.6363C21.6363 8.81827 22.9999 8.81827 22.9999 10.4092C22.9999 12.0001 21.6363 12.0001 21.6363 12.0001H21.0908V11.1819H21.7272C21.7272 11.1819 22.2393 11.1819 22.2393 10.4092ZM26.7931 8.81827H27.909L28.868 12.0001H28.0406L27.8686 11.3954H26.8197L26.6429 12.0001H25.8163L26.7931 8.81827ZM27.3514 9.65936L27.6374 10.5974H27.0601L27.3514 9.65936Z",
					fill: "#E54279"
				})
			]
		})
	}) })
});
export default SvgIdeal;
